import React from "react"

function isSafeUrl(url) {
    try {
        const base = typeof window !== "undefined" ? window.location.origin : "http://localhost"
        const parsed = new URL(url, base)
        return parsed.protocol === "http:" || parsed.protocol === "https:"
    } catch (error) {
        return false
    }
}

function StepList(props) {

    return (
        <ol>
            {props.steps.map((step, index) => (
                <li key={index}>
                    <h2>{step.overview}</h2>
                    <p>{step.details}</p>
                    <div className="stepresources">
                        {step.resources.map((resource, resourceIndex) => (
                            isSafeUrl(resource.url)
                                ? <a key={resourceIndex} href={resource.url} target="_blank" rel="noopener noreferrer">{resource.resource}</a>
                                : <span key={resourceIndex}>{resource.resource}</span>
                        ))}
                    </div>
                </li>
            ))}
        </ol>
    )
}

export default StepList
